import React from 'react';
import QuickActionCard from './QuickActionCard';

const ClaimSubmitterActions = ({ userRoles }) => {
  // Only render for claim submitters (HR, Broker, CRM) - Early return for performance
  const isClaimSubmitter = userRoles.some(role => 
    ['HR', 'Broker', 'CRM'].includes(role)
  );

  if (!isClaimSubmitter) {
    return null;
  }

  return (
    <>
      <QuickActionCard
        to="/claims/submit"
        title="Submit New Claim"
        description="Submit a new claim for processing"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        }
        iconColor="text-primary-600"
        hoverIconColor="group-hover:text-primary-700"
        titleHoverColor="group-hover:text-primary-700"
        badge="new"
      />

      <QuickActionCard
        to="/claims?status=DRAFT"
        title="Draft Claims"
        description="Continue working on saved draft claims"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        }
        iconColor="text-process-600"
        hoverIconColor="group-hover:text-process-700"
        titleHoverColor="group-hover:text-process-700"
        badge="drafts"
      />

      <QuickActionCard
        to="/claims/my-claims"
        title="My Submissions"
        description="Track status of your submitted claims"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        }
        iconColor="text-secondary-600"
        hoverIconColor="group-hover:text-secondary-700"
        titleHoverColor="group-hover:text-secondary-700"
        badge="tracking"
      />
    </>
  );
};

export default React.memo(ClaimSubmitterActions);
